import { render, staticRenderFns } from "./LayoutWithContainer.vue?vue&type=template&id=313fad12&scoped=true"
import script from "./LayoutWithContainer.vue?vue&type=script&lang=js"
export * from "./LayoutWithContainer.vue?vue&type=script&lang=js"
import style0 from "./LayoutWithContainer.vue?vue&type=style&index=0&id=313fad12&lang=scss&scoped=true"
import style1 from "./LayoutWithContainer.vue?vue&type=style&index=1&id=313fad12&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313fad12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('313fad12')) {
      api.createRecord('313fad12', component.options)
    } else {
      api.reload('313fad12', component.options)
    }
    module.hot.accept("./LayoutWithContainer.vue?vue&type=template&id=313fad12&scoped=true", function () {
      api.rerender('313fad12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Layout/LayoutWithContainer.vue"
export default component.exports